export default {
  data() {
    return {
      selected: null
    }
  },
  methods: {
    select(data) {
      this.selected = data;
    },
    getSelectedCellClassName({row}) {
      let cellClassName = '';
      if (this.selected && this.selected[this.key] === row[this.key]) {
        cellClassName += ' currentAccess ';
      }
      return cellClassName;
    },
  },
  watch: {
    selected: {
      deep: true,
      handler(value) {
        this.$emit('selected-change', value);
      }
    }
  }
}
